<script lang="ts">
  import { NCFields } from "./../../ts/NCFields";
  import { productId } from "./../../ts/Stores";

  let ncfields = NCFields.Instance();
  let ProductId: string = null;
  productId.subscribe((value) => {
    ProductId = value;
  });
</script>

{#if ncfields.editMode}
  {#if !ncfields.hasProductChanged(ProductId)}
    <input
      bind:this={ncfields.cartItemIdField}
      type="hidden"
      data-val="true"
      data-val-required="The UpdatedShoppingCartItemId field is required."
      id="addtocart_{ProductId}_UpdatedShoppingCartItemId"
      name="addtocart_{ProductId}.UpdatedShoppingCartItemId"
      value={ncfields.cartItemIdField.value}
    />
  {/if}
{/if}
<textarea
  bind:this={ncfields.settingsField}
  id={ncfields.settingsField.id}
  name={ncfields.settingsField.name}
  value={ncfields.settingsField.value}
  style="display:none"
  />
  <!-- style="width: 100%;height:300px" -->
